import axios from "axios";
import { decryptData } from "./utils/helpers";
import Vue from "vue";

const user = decryptData(
  localStorage.getItem("userInfo"),
  process.env.VUE_APP_SECRET_KEY
);

const token = user && user.token;
const vm = new Vue();
// const url =
//   process.env.NODE_ENV === "development"
//     ? // ? "https://apiv1.staging.ucemr.com"
//       // ? "http://192.168.1.18:4000"
//       "https://api.ucemr.com"
//     : // "http://localhost:3000"
//       // "https://api.ucemr.com"
//       process.env.VUE_APP_BASE_URL;

const url = `https://api.ucemr.com`;
export const api = axios.create({
  baseURL: url,
  headers: {
    common: {
      Accept: "text/plain, */*" || "JSON"
    }
  }
});

api.interceptors.response.use(
  response => response,
  error => {
    // Log the error to local storage
    const errorMessage = error.response.data.message;
    const errorLog = {
      request_method: error.config.method, // Add the request method
      endpoint_name: error.config.url,
      time: new Date().toISOString(),
      error_message: errorMessage,
      path: window.location.pathname // Include the path in the error log
    };
    const errorLogs = JSON.parse(localStorage.getItem("errorLogs")) || [];
    errorLogs.push(errorLog);
    localStorage.setItem("errorLogs", JSON.stringify(errorLogs));

    // Handle 401 Unauthorized
    if (error.response && error.response.status === 401) {
      window.location.href = "/login";
      localStorage.removeItem("userInfo");
    }

    // Forward the error to the caller
    return Promise.reject(error);
  }
);

async function handleErrorLogs() {
  const errorLogs = JSON.parse(localStorage.getItem("errorLogs"));

  if (errorLogs && errorLogs.length > 0) {
    try {
      const user = decryptData(
        localStorage.getItem("userInfo"),
        process.env.VUE_APP_SECRET_KEY
      );
      const payload = {
        userId: user,
        branchId: user?.userBranchId,
        logs: errorLogs
      };
      const response = await api.post("/error/handle", payload);

      if (response.status === 201) {
        localStorage.removeItem("errorLogs");
        console.log("Error logs handled successfully. Local storage cleared.");
      } else {
        console.log(
          "Error handling API call failed. Retrying in the next interval."
        );
      }
    } catch (error) {
      console.log(
        "Error handling API call failed. Retrying in the next interval."
      );
    }
  } else {
    console.log("No error logs found. Skipping API call.");
  }
}

// Execute handleErrorLogs every 30 minutes
setInterval(handleErrorLogs, 30 * 60 * 1000);

// Axios interceptor to include Authorization header
api.interceptors.request.use(config => {
  if (config.method === "get") {
    config.headers["Cache-Control"] = "no-cache";
    config.headers["Pragma"] = "no-cache";
  }
  if (token) {
    config.headers.Authorization = "Bearer " + token;
    if (config.url === "/user/sms") {
      config.timeout = 7000;
    }
  } else {
    delete axios.defaults.headers.common["Authorization"];
  }
  return config;
});

// Axios interceptor to handle Unauthorized response when access token needs to be refreshed.
// Handles request subscription and resends each request after token is refreshed.

api.interceptors.response.use(
  response => {
    return response;
  },

  error => {
    const originalRequest = error.config;

    // Check if we should refresh the token
    let shouldRefresh =
      token !== null &&
      error.response &&
      (error.response.status === 401 || error.response.status === 403) &&
      !originalRequest._retry;

    // Skips if the request is for token refresh
    if (originalRequest.data) {
      const data = JSON.parse(originalRequest.data);

      if (data.refresh_token) {
        shouldRefresh = false;
      }
    }

    if (shouldRefresh) {
      originalRequest._retry = true;
      return;
    } else if (error.response && error.response.status === 404) {
      vm.$toasted
        .error("Oops! We couldn't find the page you're looking for.")
        .goAway(4000);
    } else if (error.response && error.response.status) {
      if (error.response.status !== 422) {
        const response = error.response && error.response.data;
        const message = response?.message || "Something went wrong";
        vm.$toasted.error(`${message} (${error.response.status})`).goAway(3000);
      }
    } else {
      vm.$toasted
        .error("Sorry, but something went wrong. Please check your connection.")
        .goAway(4000);
    }

    return Promise.reject(error);
  }
);

export const setToken = token => {
  api.interceptors.request.use(config => {
    config.headers.Authorization = "Bearer " + token;
    return config;
  });
};
